module.exports = "mutation UpdateGuest ($userId: Int!) {\n  removeUser(userId: $userId) {\n    id\n  }\n}\n"